export default "__VITE_ASSET__zps$es04__"